<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Customer Details"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Customer Details'"
    [altColor]="false"
    [actions]="userPermissions['canEdit'] ? headerButtonActions() : []"
  >
  </aw-divider>

  <div class="info-container">
    <div>
      @for (item of customerInfoDividers(); track $index) {
      <div class="inset">
        <span class="aw-b-1 aw-text-secondary">{{ item.title }}</span>
        <span class="aw-b-1-medium aw-text-primary">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="date-container">
      @for (item of customerDateDividers(); track $index) {
      <div class="inset">
        <span class="aw-b-1 aw-text-secondary">{{ item.title }}</span>
        <span class="aw-b-1-medium aw-text-primary">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="operations-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Operations'"
        [altColor]="false"
        [altColor]="true"
      >
      </aw-divider>
      <div class="table-form-container" [ngClass]="container_theme()">
        <div>
          <aw-search
            [(ngModel)]="operationSearchValue"
            (ngModelChange)="onSearchTable(operationSearchValue)"
            ariaLabel="Search Operations"
            [placeholder]="'Search'"
          >
            <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
          </aw-search>
        </div>

        @if (userPermissions['canDelete']) {
        <Button
          AwButton
          [disable]="disableOperationsDelete"
          (click)="openDeleteOperationDialogMultiple = true"
          >Delete</Button
        >
        }
        @if (userPermissions['canEdit']) {
        <Button
          AwButton
          [disable]="disableOperationsEdit"
          (click)="openEditInfoDialog = true"
          >Edit</Button
        >
        }
        @if (userPermissions['canCreate']) {
        <Button AwButton (click)="addOperationMode = 'custom'; openAddInfoDialog = true">Add Custom Operation</Button>
        <Button AwButton (click)="addOperationMode = 'api'; openAddInfoDialog = true">Add Public API Operation</Button>
        <Button AwButton (click)="addOperationMode = 'signalr'; openAddInfoDialog = true">Add SignalR Operation</Button>
        }
      </div>
      <aw-table
        [columnsDefinition]="operationsColumnsDefinition"
        [tableData]="operationsTableData()"
        [sortDisabled]="false"
        (checkboxList)="checkBoxActionHandler($event)"
      >
      </aw-table>
      @if (openAddInfoDialog) {
        <aw-dialog
          [visible]="openAddInfoDialog"
          [formFieldsData]="getFormFieldsData()"
          [dialogOptions]="getDialogOptions()"
          (primaryAction)="addOperationFormSubmit($event)"
          (secondaryAction)="dialogFormCloseHandler('add')"
          ariaLabel="Add operation"
        >
        </aw-dialog>
      }

      @if (openEditInfoDialog) {
        <aw-dialog
          [visible]="openEditInfoDialog"
          [formFieldsData]="editFormFieldsData()"
          [dialogOptions]="editDialogOptions()"
          (primaryAction)="editOperationFormSubmit($event)"
          (secondaryAction)="dialogFormCloseHandler('edit')"
          ariaLabel="Edit operation"
        >
        </aw-dialog>
      }

      <aw-dialog
        [visible]="openDeleteOperationDialogSingle"
        [dialogOptions]="dialogOptionsDeleteSingle"
        (primaryAction)="deleteOperationFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('delete-single')"
        ariaLabel="Delete operation"
      >
      </aw-dialog>
      <aw-dialog
        [visible]="openDeleteOperationDialogMultiple"
        [dialogOptions]="dialogOptionsDeleteMultiple"
        (primaryAction)="deleteSelectedOperations()"
        (secondaryAction)="dialogFormCloseHandler('delete-multiple')"
        ariaLabel="Delete operations"
      >
      </aw-dialog>
    </div>

    <div class="api-access-container">
      <app-api-access-section
        [organizationId]="customerInfo?.organizationId ?? ''"
        [authorizedParty]="customerInfo?.organizationId ?? ''"
        (toastMessage)="buildToastMessage($event.message, $event.variant)"
      ></app-api-access-section>

      <app-api-access-section
        [mode]="'write'"
        [organizationId]="customerInfo?.organizationId ?? ''"
        [authorizedParty]="customerInfo?.organizationId ?? ''"
        (toastMessage)="buildToastMessage($event.message, $event.variant)"
      ></app-api-access-section>
    </div>
  </div>
</div>
